import { useEffect, useId, useRef } from "react";

// Painel lateral do detalhe (ex.: a composição de um mês). É um diálogo: foco no fechar ao abrir,
// Escape e o fundo fecham. No celular ocupa a largura toda.
const DirectorSidePanel = ({ title, onClose, children }) => {
  const titleId = `${useId().replace(/:/g, "-")}-title`;
  const closeRef = useRef(null);
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    closeRef.current?.focus();
    const handleKey = (event) => {
      if (event.key !== "Escape") return;
      event.preventDefault();
      onCloseRef.current?.();
    };
    document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, []);

  return <>
    <button type="button" className="director-side-panel__backdrop" aria-label="Fechar o painel pelo fundo" onClick={onClose} />
    <aside className="director-side-panel" role="dialog" aria-modal="true" aria-labelledby={titleId}>
      <header>
        <h2 id={titleId}>{title}</h2>
        <button ref={closeRef} type="button" className="director-link-button director-link-button--secondary" onClick={onClose}>
          Fechar
        </button>
      </header>
      <div className="director-side-panel__body">{children}</div>
    </aside>
  </>;
};

export default DirectorSidePanel;
